import { useCmsStore } from "@/components/AppHooks";
import { ResultsMaster } from "./master";
import { ResultsSmirnoff } from "./smirnoff";
import { ResultsTanqueray } from "./tanqueray";
import { styleName } from "@/config/const";
import { TResultsProps, TResultTanquerayProps } from "./type";
export function Results(props: {
    component: Array<TResultsProps | TResultTanquerayProps>
}) {
    const { storeConfig: { storeStyleName = styleName.Master } } = useCmsStore()!
    const pageProps = props.component.find((item) => item.storeStyleName === storeStyleName)
    return (
        <>
            {storeStyleName === styleName.Master && <ResultsMaster {...pageProps as TResultsProps} />}
            {storeStyleName === styleName.SmirnoffKenya && <ResultsSmirnoff {...pageProps as TResultsProps} />}
            {storeStyleName === styleName.Tanqueray && <ResultsTanqueray {...pageProps as TResultTanquerayProps} />}
        </>
    );
}